<header id="app-header">
    <div class="header-element">
        <div class="navigation-title">
            <div *ngIf="canShowMenu && !appRootService.currentAppConfig?.isGlobalNavigationHidden" id="app-navigation-wrapper">
                <app-nav></app-nav>
            </div>
            <div id="app-title-wrapper">
                <h1 *ngIf="appRootService.currentAppConfig" class="e2e-app-title">
                    <a *ngIf="appRootService.currentAppConfig.routerLink && !appRootService.currentAppConfig?.isGlobalNavigationHidden"
                       (click)="navigateTo(appRootService.currentAppConfig?.routerLink)">
                        {{appRootService.currentAppConfig.name}}
                    </a>
                    <span *ngIf="appRootService.currentAppConfig.routerLink && appRootService.currentAppConfig?.isGlobalNavigationHidden">
                        {{ appRootService.currentAppConfig.name }}
                    </span>
                    <span *ngIf="!appRootService.currentAppConfig.routerLink">
                        {{ appRootService.currentAppConfig.name }}
                    </span>
                    <span *ngIf="appRootService.currentAppConfig.code === 'home'">
                        {{ homeName }}
                    </span>
                </h1>
            </div>

            <div id="app-internal-navigation"
                 class="sep-left"
                 *ngIf="appRootService?.currentAppConfig?.tabs">
                <tab-navigation [tabs]="appRootService.currentAppConfig.tabs"
                                display="columns"
                                (onChangeTab)="navigateTab($event)">
                </tab-navigation>
            </div>
            <div *ngIf="appRootService?.currentAppConfig?.isShowPriceSwitcher">
                <price-switcher [hasSeparatorBefore]="appRootService?.currentAppConfig?.tabs?.length | isTruely"></price-switcher>
            </div>
            <div *ngIf="canShowDevFunctionality">
                <mock4all-input ></mock4all-input>
                <dummy-checkbox></dummy-checkbox>
            </div>

        </div>

        <div class="app-secondary-title-wrapper" *ngIf="appRootService.currentAppConfig?.secondaryName">
            <div class="title">
                <app-header-title></app-header-title>
            </div>
        </div>

        <div id="app-auth-wrapper" *ngIf="!appRootService.currentAppConfig?.isGlobalNavigationHidden">
            <app-header-user></app-header-user>
        </div>
    </div>

</header>
